import * as React from "react";

import styled from "@emotion/styled";
import Box from "../mui/Box";
import Stack from "../mui/Stack";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import Pagination from "../mui/Pagination";

interface Props {
  handlePaginationChange: (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => void;
  activePaginationPageNo: number;
  rowData: any[];
  isLoading: boolean;
  centreCount:any;
}
const LeaderoardTableMUI: React.FC<Props> = (props) => {
  const { handlePaginationChange, activePaginationPageNo, rowData, isLoading , centreCount} =
    props;
  let data: any[] = [];
  if (rowData && rowData.length > 0 && Array.isArray(rowData)) {
    data = [...rowData];
  }
  
  const totalCount = Math.ceil(centreCount?.length / 10);

  return (
    <Stack justifyContent="center">
      <StyledTableContainer>
        <StyledTable>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#CDCDCD",position:"sticky", top:"0px" , zIndex:6 }}>
              <StyledStickyHeaderTableCellLeft0>
                Rank
              </StyledStickyHeaderTableCellLeft0>
              <StyledStickyHeaderTableCellLeft50>
                Centre
              </StyledStickyHeaderTableCellLeft50>
              <StyledStickyHeaderTableCellLeft150>
                Region
              </StyledStickyHeaderTableCellLeft150>
              <StyledStickyHeaderTableCellLeft300>
                Funder
              </StyledStickyHeaderTableCellLeft300>
              <ProgrammePerformanceParameterTableCell
                colSpan={data[0]?.parameters[0]?.parameterDetails?.length || []}
              >
                Programme Performance Parameters
              </ProgrammePerformanceParameterTableCell>
              <ProgrammePerformanceParameterTableCell
                colSpan={data[0]?.parameters[1]?.parameterDetails?.length || []}
              >
                Quality and Efficacy Parameters
              </ProgrammePerformanceParameterTableCell>
              <StyledHeaderTableCell>
                Programme Performance Parameters
              </StyledHeaderTableCell>
              <StyledHeaderTableCell>
                Quality and Efficacy Parameters
              </StyledHeaderTableCell>
              <StyledHeaderTableCell>Final score</StyledHeaderTableCell>
            </TableRow>
            {data?.length === 0 ? null : (
              <>
                <TableRow sx={{ backgroundColor: "#FFFDF4" }}>
                  <StyledStickyHeaderRowSecondTableCellLeft0
                    sx={{ backgroundColor: "red !importent" }}
                    rowSpan={2}
                  ></StyledStickyHeaderRowSecondTableCellLeft0>
                  <StyledStickyHeaderRowSecondTableCellLeft50
                    rowSpan={2}
                  ></StyledStickyHeaderRowSecondTableCellLeft50>
                  <StyledStickyHeaderRowSecondTableCellLeft150
                    rowSpan={2}
                  ></StyledStickyHeaderRowSecondTableCellLeft150>
                  <StyledStickyHeaderRowSecondTableCellLeft300
                    rowSpan={2}
                  ></StyledStickyHeaderRowSecondTableCellLeft300>
                  {data[0]?.parameters[0]?.parameterDetails?.map(
                    (parameter: any, index: number) => {
                      return (
                        <>
                          <StyledHeaderTableCell1 key={`program-param-${index}`}>
                            <Tooltip title={parameter?.parameterName}>
                              <span>
                                {parameter?.parameterName.length > 20 ? (
                                  <>
                                    {parameter?.parameterName.slice(0, 20) ||
                                      "-"}
                                    ...
                                  </>
                                ) : (
                                  parameter?.parameterName || "-"
                                )}
                              </span>
                            </Tooltip>
                          </StyledHeaderTableCell1>
                        </>
                      );
                    }
                  )}
                  {data[0]?.parameters[1]?.parameterDetails?.map(
                    (parameter: any, index: number) => {
                      return (
                        <>
                          <StyledHeaderTableCell1 key={`quality-param-${index}`}>
                            <Tooltip title={parameter?.parameterName}>
                              <span>
                                {parameter?.parameterName.length > 20 ? (
                                  <>
                                    {parameter?.parameterName.slice(0, 20) ||
                                      "-"}
                                    ...
                                  </>
                                ) : (
                                  parameter?.parameterName || "-"
                                )}
                              </span>
                            </Tooltip>
                          </StyledHeaderTableCell1>
                        </>
                      );
                    }
                  )}
                  <StyledHeaderTableCell1></StyledHeaderTableCell1>
                  <StyledHeaderTableCell1></StyledHeaderTableCell1>
                  <StyledHeaderTableCell1></StyledHeaderTableCell1>
                </TableRow>
                <TableRow sx={{ backgroundColor: "#FFFDF4" }}>
                  {data[0]?.parameters[0]?.parameterDetails?.map(
                    (parameter: any) => {
                      return (
                        <>
                          <StyledHeaderTableCell2>
                            {parameter?.score || "0"}
                          </StyledHeaderTableCell2>
                        </>
                      );
                    }
                  )}
                  {data[0]?.parameters[1]?.parameterDetails?.map(
                    (parameter: any) => {
                      return (
                        <>
                          <StyledHeaderTableCell2>
                            {parameter?.score || "0"}
                          </StyledHeaderTableCell2>
                        </>
                      );
                    }
                  )}
                  <StyledHeaderTableCell2>
                    {data[0]?.parameters[0]?.sumScore || "100"}
                  </StyledHeaderTableCell2>
                  <StyledHeaderTableCell2>
                    {data[0]?.parameters[1]?.sumScore || "100"}
                  </StyledHeaderTableCell2>
                  <StyledHeaderTableCell2>
                    {data?.[0]?.totalSumScore || "200"}
                  </StyledHeaderTableCell2>
                </TableRow>
              </>
            )}
          </TableHead>
          <TableBody>
            {data?.length === 0 ? (
              <StyledStickyBodyTableCellFullWidth colSpan={12}>
                No row data
              </StyledStickyBodyTableCellFullWidth>
            ) : (
              data?.map((row, rowIndex) => (
                <TableRow key={rowIndex}>
                  <StyledStickyBodyTableCellLeft0>
                    {row?.rank || "-"}
                  </StyledStickyBodyTableCellLeft0>
                  <StyledStickyBodyTableCellLeft50>
                    {row?.centerName || "-"}
                  </StyledStickyBodyTableCellLeft50>
                  <StyledStickyBodyTableCellLeft150>
                    {row?.region || "-"}
                  </StyledStickyBodyTableCellLeft150>
                  <StyledStickyBodyTableCellLeft300>
                    {row?.funderName || "-"}
                  </StyledStickyBodyTableCellLeft300>
                  {row?.parameters[0]?.parameterDetails?.map(
                    (parameter: any, index: number) => {
                      return (
                        <StyledBodyTableCell
                          key={`row-${rowIndex}-program-${index}`}
                        >
                          {parameter?.scoreAchieved || "0"}
                        </StyledBodyTableCell>
                      );
                    }
                  )}
                  {row?.parameters[1]?.parameterDetails?.map(
                    (parameter: any, index: number) => {
                      return (
                        <StyledBodyTableCell
                          key={`row-${rowIndex}-quality-${index}`}
                        >
                          {parameter?.scoreAchieved || "0"}
                        </StyledBodyTableCell>
                      );
                    }
                  )}
                  <StyledBodyTableCell>
                    {row?.parameters[0]?.sumScoreAchieved || "0"}
                  </StyledBodyTableCell>
                  <StyledBodyTableCell>
                    {row?.parameters[1]?.sumScoreAchieved || "0"}
                  </StyledBodyTableCell>
                  <StyledBodyTableCell>
                    {row?.totalSumScoreAchieved || "0"}
                  </StyledBodyTableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </StyledTable>
      </StyledTableContainer>
      {/* Paginations  */}
      <Box
        sx={{
          backgroundColor: "#FFFFFF",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "8px",
          height: "68px",
          borderBottom: "1px solid #ECECEC",
          borderLeft: "1px solid #ECECEC",
          borderRight: "1px solid #ECECEC",
        }}
      >
        <Pagination
          count={totalCount || 0}
          onChange={handlePaginationChange}
          page={activePaginationPageNo}
        />
      </Box>
    </Stack>
  );
};

const StyledTableContainer = styled(TableContainer)({
  width: "100%",
  height: "100%",
  borderRadius: "8px",
  overflowX: "auto",
  border: "1px solid #ECECEC",
  maxHeight: "500px",

  
  // For WebKit Browsers (Chrome, Edge, Safari)
  "&::-webkit-scrollbar": {
    width: "8px", // Width of the scrollbar
    height: "8px", // Height of the scrollbar for horizontal scrolling
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#D1D1D1", // Scrollbar thumb color
    borderRadius: "8px", // Rounded edges for the scrollbar thumb
  },
  "&::-webkit-scrollbar-thumb:hover": {
    backgroundColor: "#B0B0B0", // Thumb color on hover
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F5F5F5", // Track color
    borderRadius: "4px",
  },

  // For Firefox
  scrollbarWidth: "thin", // Thin scrollbar
  scrollbarColor: "#D1D1D1 #F5F5F5",
});

const StyledTable = styled(Table)({
  borderCollapse: "separate",
  width: "max-content",
  borderSpacing: "0px",
  tableLayout: "fixed",
});

// Sticky first three columns of header (Row No. 1)
const StyledStickyHeaderTableCellLeft0 = styled(TableCell)({
  position: "sticky",
  left: "0px",
  zIndex: 2,
  backgroundColor: "#CDCDCD",
  fontWeight: 600,
  borderRight: "1px solid rgb(230, 228, 223)",
  width: "50px",
  padding:"8px",
  top:"0px"
});

const StyledStickyHeaderTableCellLeft50 = styled(
  StyledStickyHeaderTableCellLeft0
)({
  left: "52px", // Cumulative width of the first column
  width: "150px",
  padding:"8px",
});

const StyledStickyHeaderTableCellLeft150 = styled(
  StyledStickyHeaderTableCellLeft0
)({
  left: "202px", // Cumulative width of the first two columns (50 + 100)
  width: "100px",
  padding:"8px",
});

const StyledStickyHeaderTableCellLeft300 = styled(
  StyledStickyHeaderTableCellLeft0
)({
  left: "302px",
  width: "130px",
  padding:"8px",
});

// Sticky first three columns of header (Row No. 2)
const StyledStickyHeaderRowSecondTableCellLeft0 = styled(TableCell)({
  position: "sticky",
  left: "0px",
  zIndex: 2,
  backgroundColor: "rgb(255, 253, 245)",
  fontWeight: 600,
  borderRight: "1px solid rgb(230, 228, 223)",
  width: "50px",
  // padding: 0,
  padding:"8px",
  top:"42px"
});

const StyledStickyHeaderRowSecondTableCellLeft50 = styled(
  StyledStickyHeaderRowSecondTableCellLeft0
)({
  left: "52px",
  width: "150px",
  padding:"8px",
});

const StyledStickyHeaderRowSecondTableCellLeft150 = styled(
  StyledStickyHeaderRowSecondTableCellLeft0
)({
  left: "202px", // Cumulative width of the first two columns (50 + 100)
  width: "100px",
  padding:"8px",
});

const StyledStickyHeaderRowSecondTableCellLeft300 = styled(
  StyledStickyHeaderRowSecondTableCellLeft0
)({
  left: "302px",
  width: "130px",
  padding:"8px",
});

// Sticky first three columns of table body
const StyledStickyBodyTableCellFullWidth = styled(TableCell)({
  position: "sticky",
  left: "0px",
  backgroundColor: "#ffffff",
  borderRight: "1px solid rgb(230, 228, 223)",
  width: "50px",
  textAlign: "center",
  padding:"8px",
});

const StyledStickyBodyTableCellLeft0 = styled(TableCell)({
  position: "sticky",
  left: "0px",
  backgroundColor: "#ffffff",
  borderRight: "1px solid rgb(230, 228, 223)",
  width: "50px",
  padding:"8px",
});

const StyledStickyBodyTableCellLeft50 = styled(StyledStickyBodyTableCellLeft0)({
  width: "150px",
  left: "52px",
  padding:"8px",
});

const StyledStickyBodyTableCellLeft150 = styled(StyledStickyBodyTableCellLeft0)(
  {
    left: "202px", // Cumulative width of the first two columns (50 + 100)
    width: "100px",
    padding:"8px",
  }
);

const StyledStickyBodyTableCellLeft300 = styled(StyledStickyBodyTableCellLeft0)(
  {
    left: "302px",
    width: "130px",
    padding:"8px",
  }
);

// Normal Header & Body Cell Styles
const StyledHeaderTableCell = styled(TableCell)({
  fontWeight: 600,
  fontSize: "14px",
  minWidth: "100px",
  border: "1px solid #ECECEC",
  textAlign: "center",
  padding:"8px",
  position:"sticky",
  top:"0px",
  zIndex:1,
});

const StyledHeaderTableCell1 = styled(StyledHeaderTableCell)({
  top:"42px",
  zIndex:1,
  backgroundColor: "rgb(255, 253, 245)",
});

const StyledHeaderTableCell2 = styled(StyledHeaderTableCell)({
  top:"84px",
  backgroundColor: "rgb(255, 253, 245)",
});

const ProgrammePerformanceParameterTableCell = styled(TableCell)({
  fontWeight: 600,
  fontSize: "14px",
  border: "1px solid #ECECEC",
  textAlign: "center",
  padding:"8px",
  position:"sticky",
  top:"0px",
});

const StyledBodyTableCell = styled(TableCell)({
  fontSize: "14px",
  minWidth: "100px",
  border: "1px solid #ECECEC",
  textAlign: "center",
  backgroundColor: "#ffffff",
  padding:"8px",
});

export default LeaderoardTableMUI;
